import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggleable"]
  static classes = ["hidden"]

  static values = { open: { type: Boolean, default: false } }

  openValueChanged() {
    console.log('hideValueChanged', this.openValue)
    if(this.openValue) { 
      this.toggleableTarget.classList.remove(this.hiddenClass)
    } else {
      this.toggleableTarget.classList.add(this.hiddenClass)
    }
  }

  toggle(ev) {
    console.log('toggle', this.openValue)
    this.openValue = !this.openValue
    ev.preventDefault();
  }

  hide(ev) {
    if(!this.element.contains(ev.target)) {
      this.openValue = false
    }
  }
}
